const SUCCESS_TEXT = '送信しました。ありがとうございます。';
const ERROR_TEXT = '送信に失敗しました。時間をおいて再度お試しください。';
const REQUIRED_TEXT = '内容とお名前をご入力ください。';
const RATE_LIMIT_TEXT = (seconds) =>
  `送信が頻繁すぎます。${seconds}秒後に再度お試しください。`;

class UserMessage extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.form = this.querySelector('[data-user-message-form]');
    this.submitBtn = this.querySelector('[data-user-message-submit]');
    this.statusEl = this.querySelector('[data-user-message-status]');
    if (!this.form) return;

    this.defaultBtnText = this.submitBtn?.textContent?.trim() || '';
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submit();
    });
  }

  setStatus(message, type) {
    if (!this.statusEl) return;
    this.statusEl.hidden = !message;
    this.statusEl.textContent = message || '';
    this.statusEl.classList.toggle('is-success', type === 'success');
    this.statusEl.classList.toggle('is-error', type === 'error');
  }

  setLoading(loading) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = loading;
    this.submitBtn.textContent = loading ? '送信中...' : this.defaultBtnText;
  }

  async submit() {
    if (this.submitBtn?.disabled) return;

    const content = this.form.content?.value?.trim() || '';
    const name = this.form.name?.value?.trim() || '';
    if (!content || !name) {
      this.setStatus(REQUIRED_TEXT, 'error');
      return;
    }

    const apiUrl = 'https://api.veimia.com/vm/opinion_insight/open/opinion/activity-comments/v1';

    this.setLoading(true);
    this.setStatus('', '');

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, content, siteId: '1000004502',sourcePage: location.href }),
      });
      const data = await response.json().catch(() => ({}));
      if (response.status === 429 || data.code === 429) {
        const seconds = Number(data?.data?.retryAfterSeconds);
        const wait = Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : 300;
        this.setStatus(RATE_LIMIT_TEXT(wait), 'error');
        return;
      }

      const ok = response.ok && Number(data.code) === 0;
      if (!ok) {
        this.setStatus(ERROR_TEXT, 'error');
        return;
      }

      this.form.reset();
      this.setStatus(SUCCESS_TEXT, 'success');
      this.trackSubmitSuccess(content, name);
    } catch (error) {
      this.setStatus(ERROR_TEXT, 'error');
    } finally {
      this.setLoading(false);
    }
  }

  trackSubmitSuccess(content, name) {
    const sensors = window.sensors;
    if (!sensors || typeof sensors.track !== 'function' || !this.submitBtn) return;

    const eventName = this.submitBtn.getAttribute('data-sensors-click-event-name') || 'slot_click';
    const prefix = 'data-sensors-click-property-';
    const props = {};
    for (const attr of this.submitBtn.attributes) {
      if (attr.name.startsWith(prefix)) {
        props[attr.name.slice(prefix.length)] = attr.value;
      }
    }
    props.extra_data = `${content}-${name}`;
    sensors.track(eventName, props);
  }
}

if (!customElements.get('user-message')) {
  customElements.define('user-message', UserMessage);
}
